// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"1":"67d0a0a83df63ebc2fdd","298":"1e4e4c983ed0943fb774"}[chunkId] + ".js";
};